import React from 'react';
import { cn } from '@/lib/utils';

// Linear/Vercel-style status badges: neutral surface with a colored dot
const VARIANT_DOTS = {
  default: 'bg-[var(--text-muted)]',
  success: 'bg-[var(--status-success)]',
  warning: 'bg-[var(--status-warning)]',
  danger: 'bg-[var(--status-danger)]',
  info: 'bg-[var(--brand-cyan)]',
  purple: 'bg-violet-500'
};

export const Badge = ({ children, variant = 'default', className, dot = true, ...rest }) => {
  return (
    <span
      {...rest}
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md',
        'border border-[var(--border)] bg-[var(--surface)]',
        'text-[11px] font-medium text-[var(--text-secondary)]',
        'tracking-tight',
        className
      )}
    >
      {dot && (
        <span className={cn('w-1.5 h-1.5 rounded-full', VARIANT_DOTS[variant] || VARIANT_DOTS.default)} />
      )}
      {children}
    </span>
  );
};
